import React, {useEffect, useState} from 'react'
import ProductCategories from '../../categories/productCategories'
import PriceRange from '../../priceRange/priceRange'
import SortingProduct from '../../sortingProduct/sortingProduct'
import Lehanga from '../../../assets/images/lehanga.jpg'
import Wishlist from '../../models/wishlist'

const Lahangas = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const openWishlistModal = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const closeWishlistModal = () => {
        setIsModalOpen(false);
    };

    const dummyProducts = new Array(4).fill(null).map((_, index) => ({
        id: index + 1,
        name: `Product ${index + 1}`,
        description: `Description ${index + 1}`,
        imageUrl: Lehanga,
        price: "Rs 42,000.00",
    }));

    return (
        <div>Lahangas
            <ProductCategories />
            <PriceRange />
            <SortingProduct />
            {dummyProducts.map(product => (
                <div key={product.id}>
                    <img src={product.imageUrl} alt={`Product ${product.id}`} />
                    <h3>{product.name}</h3>
                    <p>{product.description}</p>
                    <button onClick={() => openWishlistModal(product)}>wishlist</button>
                    <p>{product.price}</p>
                    <button>Add to Cart</button>
                </div>
            ))}
            <Wishlist isOpen={isModalOpen} onClose={closeWishlistModal} product={selectedProduct} />
        </div>
    )
}

export default Lahangas